import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-left--sprite",
  "use": "arrow-left--sprite-usage",
  "viewBox": "0 0 7 12",
  "content": "<symbol viewBox=\"0 0 7 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-left--sprite\">\n  <path d=\"M 5.3985486,0.7864042 0.19151737,5.9934354 5.3985486,11.200466 6.8126111,9.7864042 3.0196424,5.9934354 6.8126111,2.2004667 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol